//#region Styles
import { Container } from "./styles";
//#endregion
//#region Components
//#endregion

const ListDataField = ({
    data
}) => {
    return (
        <Container>
            {data.map((dataItem, idx) => {
                return (
                    <li key={idx}>
                        {dataItem}
                    </li>
                );
            })}
        </Container>
    );
};

export default ListDataField;